import React, { Component } from 'react';
import { connect } from "react-redux";

import './happinessWidget.css';
import { todayHappiness } from '../../../redux/selectors'

import { TooltipSmiley } from '../../atoms/tooltip/tooltip';
import Emojis from '../../molecules/emojis';
import TodayHappinessAnswer from '../../molecules/todayHappinessAnswer';

class HappinessWidget extends Component {
  renderEmployeeHappiness = (tooltip, score) => {
    if(score === 8 ){
      const img = require(`../../assets/emojis/emoji-4.png`);
      return(
        <TooltipSmiley position='bottom' content='No data yet' className='fixed disabled' >
          <img alt='Emoji' src={img} />
        </TooltipSmiley>
      )
    } else {
      const img = require(`../../assets/emojis/emoji-${score}.png`);
      return(
        <TooltipSmiley position='bottom' content={tooltip} className='fixed' >
          <img alt='Emoji' src={img} />
        </TooltipSmiley>
      )
    }
  }
  render() {
    const { todayHappiness, user, score } = this.props;
    let tooltips = ['terrible', 'bad', 'ok', 'good', 'amazing'];

    const tooltip = tooltips[score - 1];

    if(user && user.loggedIn) {
      return (
        <div className='widget big flex'>
          <div className='left'>
            <h2>Today I feel...</h2>
            {!todayHappiness || !todayHappiness.score ? <Emojis /> : <TodayHappinessAnswer/> }
          </div>
          <div className='right flex'>
            <h3>Overall employee happiness</h3>
            {this.renderEmployeeHappiness(tooltip, score)}
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    todayHappiness: todayHappiness(state),
    score: state.general.company.employeeHappiness,
  };
}

export default connect(mapStateToProps)(HappinessWidget);
